<template>
  <div
    class="progress-circular"
    :style="progressAreaStyle"
  >
    <svg
      class="progress-svg"
      :style="svgRotateStyle + progressAreaStyle"
    >
      <circle
        :cx="centerOffset"
        :cy="centerOffset"
        :r="radius"
        :stroke="bgColor"
        :stroke-width="weight"
        fill="none"
      />
      <circle
        :cx="centerOffset"
        :cy="centerOffset"
        :r="radius"
        :stroke="color"
        :stroke-width="weight"
        fill="none"
        :stroke-dasharray="strokeDasharray"
        :stroke-dashoffset="`${strokeDashoffset}px`"
        class="stroke-transition"
      />
    </svg>
    <i v-if="isLock" class="lock mdi mdi-lock"></i>
    <span v-else class="show-text" :style="showTextStyle">{{showText}}</span>
  </div>
</template>

<script>
  export default {
    name: "ProgressCircular",
    data() {
      return {
        strokeDashoffset: '0',
      }
    },
    props: {
      width: {
        default: 100
      },
      weight: {
        default: 10
      },
      color: {
        default : '#00BB2C'
      },
      bgColor: {
        default : '#E5E5EA'
      },
      value: {
        required: true
      },
      text: {
        default: ''
      },
      fontSize: {
        default: 16
      },
      fontColor: {
        default: ''
      },
      isLock: {
        default: false
      }
    },
    computed: {
      progressAreaStyle() {
        return `width: ${this.width}px; height: ${this.width}px;`
      },
      svgRotateStyle() {
        return `transform-origin: ${this.width / 2}px ${this.width / 2}px; transform: rotate(-90deg);`
      },
      showTextStyle() {
        return `color:${this.textColor}; font-size: ${this.fontSize}px`
      },
      centerOffset() {
        return this.width / 2
      },
      radius() {
        return (this.width - this.weight) / 2
      },
      strokeDasharray() {
        return this.radius * 3.14 * 2
      },
      strokeDashoffsetCalc() {
        let ratio = (100 - this.value <= 0) ? 0 : (100 - this.value) / 100
        return this.strokeDasharray * ratio
      },
      showText() {
        if(this.text){
          return this.text
        } else {
          return this.value
        }
      },
      textColor() {
        if(this.fontColor){
          return this.fontColor
        } else {
          return this.color
        }
      }
    },
    methods: {
      renderAnime() {
        setTimeout(() => {
          this.strokeDashoffset = this.strokeDashoffsetCalc
        }, 100)
      }
    },
    watch: {
      value() {
        this.renderAnime()
      }
    },
    beforeMount() {
      this.strokeDashoffset = this.strokeDasharray
    },
    mounted() {
      this.renderAnime()
    }
  }
</script>

<style lang="scss" scoped>
  .progress-circular {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .progress-svg {
      position: absolute;
      top: 0;
      left: 0;
      .stroke-transition {
        z-index: 2;
        transition: all .6s ease-in-out;
      }
    }
    .lock {
      color: #E5E5EA;
    }
    .show-text {

    }
  }

</style>